import { themeColors } from "../palette";

export default {
  styleOverrides: {
    root: {
      color: themeColors.textPrimary,
      backgroundColor: themeColors.bgPaper, 
    },
  },
}